import React from 'react';
import {compose, pure, lifecycle} from 'recompose';
import {withRouter} from 'react-router-dom';
import {Formik} from 'formik';
import Disclaimer from '../../components/Disclaimer';
import View from '../../components/View';
import FileAttachment from '../../components/FileAttachment';
import {metric} from '../../utils/metrics';
import {sendApplyRequest} from '../../services/api';
import {parseQueryString} from '../../utils/urlUtils';

const ApplyView = (props) => {
  const queryParams = parseQueryString(props.location.search);
  return (
    <View title="Отклик на вакансию Data Scientist" className="view--apply">
      <Formik
        initialValues={{
          firstName: queryParams.first_name || '',
          lastName: queryParams.last_name || '',
          phone: queryParams.phone || '',
          email: queryParams.email || '',
          bio: '',
          attachment: null,
          vacancyId: process.env.REACT_APP_APPLY_VACANCY_ID,
          formToken: process.env.REACT_APP_LANDING_TOKEN,
          ref: process.env.REACT_APP_COMPANY_TOKEN,
        }}
        onSubmit={(values, {setSubmitting}) => {
          setSubmitting(true);

          sendApplyRequest(values)
            .then((response) => {
              console.info(response);
              metric('reachGoal', 'click-apply');
              //props.history.push('/apply/thankyou');
              window.location.replace(response.video_interview_link);
            })
            .catch((err) => {
              console.error(err);
              setSubmitting(false);
            });
        }}
        render={({ setFieldValue, handleChange, handleBlur, handleSubmit, isSubmitting, initialValues }) => (
          <form method="get" className="form" onSubmit={handleSubmit}>
            <input name="ref" type="hidden" value={initialValues.ref} />
            <div className="form__item">
              <input
                defaultValue={initialValues.firstName}
                required={true}
                name="firstName"
                type="text"
                className="input input--text"
                placeholder="Имя"
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className="form__item">
              <input
                defaultValue={initialValues.lastName}
                required={true}
                name="lastName"
                type="text"
                className="input input--text"
                placeholder="Фамилия"
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className="form__item">
              <input
                defaultValue={initialValues.phone}
                required={true}
                name="phone"
                type="tel"
                className="input input--text"
                placeholder="Номер телефона"
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className="form__item">
              <input
                defaultValue={initialValues.email}
                required={true}
                name="email"
                type="email"
                className="input input--text"
                placeholder="Электронная почта"
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className="form__item">
              <textarea
                defaultValue={initialValues.bio}
                required={true}
                name="bio"
                rows={3}
                className="input input--textarea"
                placeholder="Рассказ о себе"
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className="form__item">
              <FileAttachment
                required={true}
                name="file"
                onChange={(file) => {
                  setFieldValue('file', file);
                }}
                mimeTypes="application/x-iwork-pages-sffpages,application/rtf,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,"
              >
                Прикрепить резюме
              </FileAttachment>
            </div>
            <div className="form__item">
              <button
                type="submit"
                disabled={isSubmitting}
                className="button button--dark"
              >
                {isSubmitting ? 'Отправка...' : 'Отправить'}
              </button>
            </div>
            <div className="form__item">
              <Disclaimer label="Отправить" />
            </div>
          </form>
        )}
      />
    </View>
  );
};

const enhance = compose(
  lifecycle({
    componentDidMount() {
      metric('hit', '/apply');
    }
  }),
  withRouter,
  pure,
);

export default enhance(ApplyView);
